'use client';
/** Конкатенирует переданный набор строк, вставляя между соседними перенос строки. */ var lines = function() {
    for(var _len = arguments.length, raws = new Array(_len), _key = 0; _key < _len; _key++){
        raws[_key] = arguments[_key];
    }
    return raws.filter(Boolean).join("\n");
};

export { lines };
